const EmptyProvider = () => {
  return null;
};

export default EmptyProvider;
